import { accessRole } from "../../../helpers/access_role"
import ErrorAccess from '../../../components/Error/Content/Access'
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"

import Index from './Index/View'
import Pegawai from './Pegawai/View'
import Atasan from './Atasan/View'
import AddPegawai from './AddPegawai/View'
import VerifikasiPegawai from './VerifikasiPegawai/View'
import Create from './Create/View'
import CreatemanualHukdis from './CreateManualHukdis/View'
import BerkasUpload from './BerkasUpload/View'
import DetailPegawai from './DetailPegawai/View'
import DetailRekomendasi from './Detailrekomendasi/View'
import Pemanggilan from './CreateSP/View'
import Update from './Update/View'
import Uploadhasil from './Uploadhasil/View'
import UploadSK from './UploadSK/View'
import Detail from './Detail/View'
import DetailmanualHukdis from './DetailManualHukdis/View'

const RouteView = (props) => {
    const { params } = props    
	const queryParams = new URLSearchParams(props.location.search);
    const _id = queryParams.get('id')
    const _uuid = queryParams.get('uuid')
    const _pegawai_uuid = queryParams.get('pegawai_uuid')
    const _create = queryParams.get('create')
    const _createManual = queryParams.get('create_manual_hukdis')
    const _list = queryParams.get('list')
    const _detail = queryParams.get('detail')
    const _detailManual = queryParams.get('detailmanual')
    const _update = queryParams.get('update')
    const _delete = queryParams.get('delete')
    const _approve = queryParams.get('approve')
    const _print = queryParams.get('print')
    const _pegawai = queryParams.get('pegawai')
    const _atasan = queryParams.get('listatasan')
    const _addpegawai = queryParams.get('addpegawai')
    const _verifikasi = queryParams.get('verifikasi')
    const _berkas = queryParams.get('berkas')
    const _inputpemanggilan = queryParams.get('inputpemanggilan')
    const _uploadhasil = queryParams.get('upload_hasil')
    const _upload_sk = queryParams.get('upload_sk')
    const _detailrekomendasi = queryParams.get('detailrekomendasi')
    
    if (_pegawai != null) {
        return accessRole('update') ? <Pegawai uuid={_uuid}  /> : <ErrorAccess />
    }
    if (_atasan != null) {
        return accessRole('update') ? <Atasan uuid={_uuid}  /> : <ErrorAccess />
    }
    if (_addpegawai != null) {
        return accessRole('update') ? <AddPegawai uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_verifikasi != null) {
        return accessRole('update') ? <VerifikasiPegawai uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_create != null) {
        return accessRole('create') ? <Create/> : <ErrorAccess />
    }
    if (_createManual != null) {
        return accessRole('create') ? <CreatemanualHukdis/> : <ErrorAccess />
    }
    if (_berkas != null) {
        return accessRole('update') ? <BerkasUpload uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_detail != null) {
        return accessRole('read') ? <Detail uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_detailManual != null) {
        return accessRole('read') ? <DetailmanualHukdis uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_detailrekomendasi != null) {
        return accessRole('read') ? <DetailRekomendasi uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_inputpemanggilan != null) {
        return accessRole('read') ? <Pemanggilan uuid={_uuid} pegawai_uuid={_pegawai_uuid}  /> : <ErrorAccess />
    }
    if (_update != null) {
        return accessRole('update') ? <Update uuid={_uuid} /> : <ErrorAccess />
    }
    if (_uploadhasil != null) {
        return accessRole('update') ? <Uploadhasil uuid={_uuid} /> : <ErrorAccess />
    }
    if (_upload_sk != null) {
        return accessRole('update') ? <UploadSK uuid={_uuid} /> : <ErrorAccess />
    }
    // Jika Admin
    if (accessRole('approve')) {
        return accessRole('read') ? <Index /> : <ErrorAccess />
    } else {
        return accessRole('read') ? <Index /> : <ErrorAccess />
        // return accessRole('read') ? null : <ErrorAccess />
    }

}

export default RouteView